"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;
var _redux = require("redux");
var _reduxImmutableStateInvariant = _interopRequireDefault(require("redux-immutable-state-invariant"));
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _reduxResponsive = require("redux-responsive");
/* eslint-env node, browser */
// This file merely configures the store for hot reloading.
// This boilerplate file is likely to be the same for each project that uses Redux.
// With Redux, the actual stores are in /reducers.

function configureStore(initialState, axiosClients) {
  return (0, _redux.createStore)(window.dkeReactLauncher.rootReducer, initialState, (0, _redux.compose)(_reduxResponsive.responsiveStoreEnhancer, (0, _redux.applyMiddleware)(_reduxThunk.default, (0, _reduxImmutableStateInvariant.default)()), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
    return f;
  } // add support for Redux dev tools
  ));
}